var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLts1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 86,
    viewBox: "0 0 107 86",
    fill: "none",
    id: "svg40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_6435)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1527 67.3353L57.1277 66.7328C57.1139 66.4001 56.833 66.1416 56.5003 66.1553L52.5844 66.3176L48.6687 66.4799C48.336 66.4937 48.0775 66.7746 48.0913 67.1073L48.1162 67.7097M57.1527 67.3353L66.9863 66.9277C67.2326 66.9175 67.4604 67.0583 67.5614 67.2833L67.7627 67.7319C67.9529 68.1556 67.9729 68.6363 67.8184 69.0743L67.6548 69.5381C67.5728 69.7706 67.3575 69.9297 67.1111 69.9399L66.6509 69.959C66.4416 69.9677 66.2545 70.0793 66.1456 70.2583C65.2543 71.7236 60.9027 78.3442 54.9036 78.5928L51.2891 78.7426C45.29 78.9912 40.4055 72.7534 39.396 71.3669C39.2727 71.1975 39.0769 71.1017 38.8676 71.1104L38.4074 71.1295C38.1611 71.1397 37.9333 70.9989 37.8324 70.774L37.631 70.3253C37.4408 69.9016 37.4209 69.4209 37.5754 68.9829L37.7389 68.5191C37.8209 68.2866 38.0363 68.1275 38.2826 68.1173L48.1162 67.7097M57.1527 67.3353L57.2775 70.3475M57.2775 70.3475L57.2962 70.7993C57.31 71.132 57.0515 71.4129 56.7188 71.4267L48.8872 71.7513C48.5545 71.765 48.2736 71.5065 48.2598 71.1738L48.241 70.722M57.2775 70.3475L60.72 70.2048C61.1908 70.1853 61.4821 70.6772 61.2052 71.0585C60.1917 72.4541 57.921 74.9977 54.76 75.1287L51.1455 75.2785C47.9846 75.4095 45.5111 73.0625 44.3856 71.7555C44.0781 71.3984 44.3278 70.8841 44.7986 70.8646L48.241 70.722M48.1162 67.7097L48.241 70.722",
    stroke: "#63B281",
    strokeWidth: 2.11035,
    strokeLinecap: "round",
    id: "path1",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.3775 67.1782C68.9713 61.453 62.4493 57.5813 54.9631 57.5813H51.4044C43.9183 57.5813 37.3962 61.453 33.99 67.1782",
    stroke: "#63B281",
    strokeWidth: 2.4483,
    id: "path2",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1155 67.3618C84.8104 67.1258 89.0738 68.5739 89.2172 72.0341C89.3248 74.6292 93.1745 76.9609 93.1745 76.9609",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path3",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1201 67.47C86.1638 67.1781 87.2902 70.1942 87.4458 73.9489C87.5625 76.7649 90.6672 78.0397 90.6672 78.0397",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path4",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1201 67.47C82.4995 67.3299 85.0625 68.9867 85.2181 72.7414C85.3348 75.5574 85.9856 77.3672 85.9856 77.3672",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path5",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1226 67.5344C85.104 67.2865 82.8528 71.7006 83.0069 75.4193C83.1225 78.2083 83.4948 78.9393 83.4948 78.9393",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path6",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1201 67.47C83.4662 67.2899 80.0813 72.551 80.2369 76.3056C80.3536 79.1216 80.7652 81.8079 80.7652 81.8079",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path7",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8457 69.5696C20.1508 69.8056 16.0218 71.6014 16.1652 75.0616C16.2727 77.6568 12.6292 80.299 12.6292 80.299",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path8",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8503 69.6777C18.8067 69.9696 17.9337 73.0686 18.0893 76.8233C18.206 79.6393 15.2174 81.1667 15.2174 81.1667",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path9",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8503 69.6777C22.471 69.8178 20.0538 71.681 20.2094 75.4357C20.3261 78.2516 19.8273 80.1091 19.8273 80.1091",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path10",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.853 69.7422C19.8716 69.9901 22.4803 74.2028 22.6344 77.9215C22.75 80.7105 22.4394 81.4697 22.4394 81.4697",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path11",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8503 69.6777C21.5042 69.8578 25.3129 74.8208 25.4685 78.5755C25.5852 81.3915 25.3973 84.1026 25.3973 84.1026",
    stroke: "#63B281",
    strokeWidth: 1.38222,
    strokeLinecap: "round",
    id: "path12",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8923 48.8938L65.6314 50.9563C65.6041 51.172 65.7879 51.3612 65.9974 51.4197C67.0306 51.7079 68.1222 53.2686 66.3418 54.8364C65.2242 55.8205 64.0656 54.7887 63.8441 54.6406C61.5941 58.1998 59.0162 61.7144 53.5475 61.0227C48.9439 60.4403 46.4573 56.2851 45.1644 52.2778C44.913 52.3661 43.3197 52.8706 42.4824 51.6392C41.1445 49.6716 42.7859 48.4561 43.9031 48.4475C44.1205 48.4458 44.3454 48.3069 44.3726 48.0913L44.6116 46.202C44.864 45.4732 47.6837 42.047 55.8176 43.0759C63.9516 44.1047 65.8293 48.1251 65.8923 48.8938Z",
    fill: "#F3F3F0",
    id: "path13",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4416 48.897C43.4075 48.5259 41.0854 49.7905 42.6046 52.0246C43.4419 53.256 44.821 52.5452 45.0724 52.4569C45.9899 59.4319 51.2181 60.9829 53.4475 61.2649C55.677 61.5469 61.1267 61.3465 63.7521 54.8197C63.9736 54.9678 65.1322 55.9996 66.2498 55.0155C68.2774 53.23 66.3433 51.4271 65.2494 51.5289M69.6908 45.8156C70.7562 37.3926 65.7348 31.7799 57.3119 30.7145C48.8889 29.6491 42.6281 33.8347 41.5627 42.2577C41.4638 43.0397 41.4254 43.8154 41.4441 44.5801C41.4781 45.9782 42.9154 47.7883 43.8113 48.8172C43.9465 48.9725 44.2017 48.8949 44.2275 48.6906L44.5196 46.3811C44.772 45.6523 47.6292 41.9293 55.7632 42.9582C63.8971 43.987 65.7374 48.3042 65.8003 49.0729L65.5633 50.9461C65.523 51.2651 65.9072 51.4566 66.1376 51.2322L67.6469 49.7622C68.4239 49.0055 69.1129 48.1238 69.4365 47.0885C69.5401 46.7573 69.6189 46.3845 69.6908 45.8156Z",
    stroke: "#63B281",
    strokeWidth: 2.03903,
    id: "path14",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0098 50.7502L58.983 50.9618",
    stroke: "#63B281",
    strokeWidth: 1.75516,
    strokeLinecap: "round",
    id: "path15",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3931 49.7869L51.3663 49.9984",
    stroke: "#63B281",
    strokeWidth: 1.75516,
    strokeLinecap: "round",
    id: "path16",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9868 55.957V55.957C54.9897 56.2427 53.9192 56.1072 53.0247 55.5823V55.5823",
    stroke: "#63B281",
    strokeWidth: 1.27959,
    strokeLinecap: "round",
    id: "path17",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9598 56.8191V56.8191C56.598 56.2453 56.5019 55.543 56.6963 54.8931V54.8931",
    stroke: "#63B281",
    strokeWidth: 1.27959,
    strokeLinecap: "round",
    id: "path18",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8746 56.1757V56.1757C52.3679 55.7101 52.6358 55.0539 52.6094 54.376V54.376",
    stroke: "#63B281",
    strokeWidth: 1.27959,
    strokeLinecap: "round",
    id: "path19",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4567 50.8808L54.2276 49.8127C54.7062 49.1496 55.7317 49.2916 56.012 50.0599L56.4721 51.3207C56.6949 51.9315 56.402 52.61 55.8046 52.8668C55.1263 53.1583 54.3354 53.0625 53.7401 52.6258C53.1869 52.22 53.0552 51.4371 53.4567 50.8808Z",
    fill: "#63B281",
    id: "path20",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4795 30.72L56.1007 35.1385C56.0552 35.6696 56.4369 36.1419 56.9657 36.2088V36.2088C57.4945 36.2757 57.9818 35.9133 58.0699 35.3876L58.8033 31.0139",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path21",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4878 30.6545L56.109 35.0731C56.0635 35.6042 56.4452 36.0765 56.974 36.1434V36.1434C57.5028 36.2102 57.9901 35.8479 58.0782 35.3222L58.8116 30.9485",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path22",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3406 31.0659L57.9997 22.7791C58.0582 22.4868 58.3326 22.2894 58.6283 22.3268V22.3268C58.924 22.3642 59.1406 22.6237 59.1245 22.9214L58.6679 31.3603",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path23",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6785 31.5935L50.4716 36.1251C50.5695 36.6842 51.092 37.0658 51.6544 36.9889V36.9889C52.2171 36.9119 52.6179 36.4035 52.5616 35.8384L52.0648 30.8559",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path24",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0707 32.3074L61.3697 36.9525C61.1745 37.4858 61.4361 38.0779 61.9619 38.2926V38.2926C62.4874 38.5072 63.0885 38.2677 63.3225 37.7505L65.219 33.5591",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path25",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2745 36.5839L65.8594 40.1522C65.5568 40.5992 65.6565 41.2048 66.0864 41.5313V41.5313C66.5146 41.8564 67.1219 41.7918 67.4721 41.3839L69.4586 39.0704",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path26",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0559 33.6982L47.5347 37.8344C47.7165 38.3427 47.4691 38.9044 46.9715 39.1135V39.1135C46.4758 39.3217 45.9038 39.108 45.6661 38.6258L44.239 35.7297",
    stroke: "#63B281",
    strokeWidth: 1.70611,
    id: "path27",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64 42.2032C46.9179 40.8939 49.9765 39.5858 56.1243 40.3635C62.2722 41.1411 64.9087 43.1696 65.8203 44.7558",
    stroke: "#63B281",
    strokeWidth: 2.03903,
    strokeLinecap: "round",
    id: "path28",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5718 71.6034L66.4441 71.6153C65.9167 71.6643 65.4254 71.3424 65.2598 70.8393L64.7206 69.2012C64.6878 69.1016 64.669 68.9979 64.6647 68.8931L64.6074 67.5126L64.6216 65.8111C64.6257 65.3081 64.9603 64.8677 65.4438 64.7287L69.5525 63.548C69.7103 63.5027 69.876 63.4921 70.0382 63.5169L72.8919 63.9539C73.2307 64.0058 73.5279 64.2078 73.7008 64.5038L74.6047 66.0512C74.6982 66.2113 74.7511 66.3919 74.7587 66.5771L74.8133 67.8942L74.8772 69.4352C74.9023 70.0419 74.3777 70.5564 73.7054 70.5842C73.0331 70.6121 72.4677 70.1428 72.4425 69.5361L72.4653 70.0868C72.4905 70.6936 71.9658 71.208 71.2935 71.2359C70.6212 71.2637 70.0558 70.7944 70.0307 70.1877L70.0381 70.3685C70.0633 70.9753 69.5387 71.4897 68.8663 71.5176C68.194 71.5454 67.6118 70.67 67.5866 70.0632L67.6016 70.4253C67.6267 71.0295 67.174 71.5474 66.5718 71.6034Z",
    fill: "#F3F3F0",
    id: "path29",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4441 71.6153L66.5164 72.3935L66.5164 72.3935L66.4441 71.6153ZM66.5718 71.6034L66.4995 70.8251L66.4995 70.8251L66.5718 71.6034ZM66.7284 68.2292C66.7105 67.7979 67.0456 67.4338 67.4769 67.4159C67.9082 67.398 68.2724 67.7332 68.2902 68.1645L66.7284 68.2292ZM64.6074 67.5126L63.8265 67.5449L63.8257 67.5255L63.8259 67.5061L64.6074 67.5126ZM64.6216 65.8111L63.84 65.8046L63.84 65.8046L64.6216 65.8111ZM73.7008 64.5038L73.0259 64.898L73.7008 64.5038ZM74.6047 66.0512L73.9297 66.4454L74.6047 66.0512ZM69.163 68.1283C69.1452 67.697 69.4803 67.3329 69.9116 67.315C70.3429 67.2971 70.707 67.6323 70.7249 68.0636L69.163 68.1283ZM71.5977 68.0274C71.5798 67.5961 71.915 67.232 72.3463 67.2141C72.7776 67.1962 73.1417 67.5314 73.1596 67.9627L71.5977 68.0274ZM74.8133 67.8942L74.0324 67.9265L74.0324 67.9265L74.8133 67.8942ZM74.7587 66.5771L75.5397 66.5448L75.5397 66.5448L74.7587 66.5771ZM65.4438 64.7287L65.2279 63.9775L65.2279 63.9775L65.4438 64.7287ZM69.5525 63.548L69.7684 64.2992L69.7684 64.2992L69.5525 63.548ZM70.0382 63.5169L70.1565 62.7443L70.0382 63.5169ZM72.8919 63.9539L73.0102 63.1813L73.0102 63.1813L72.8919 63.9539ZM64.7206 69.2012L65.4631 68.9568L65.4631 68.9568L64.7206 69.2012ZM65.2598 70.8393L64.5174 71.0837L64.5174 71.0837L65.2598 70.8393ZM66.3717 70.837L66.4995 70.8251L66.6442 72.3816L66.5164 72.3935L66.3717 70.837ZM66.8207 70.4576L66.8057 70.0956L68.3676 70.0309L68.3826 70.3929L66.8207 70.4576ZM66.8057 70.0956L66.7284 68.2292L68.2902 68.1645L68.3676 70.0309L66.8057 70.0956ZM63.8259 67.5061L63.84 65.8046L65.4031 65.8176L65.389 67.519L63.8259 67.5061ZM74.3757 64.1096L75.2796 65.657L73.9297 66.4454L73.0259 64.898L74.3757 64.1096ZM69.2572 70.4009L69.2497 70.2201L70.8116 70.1554L70.8191 70.3362L69.2572 70.4009ZM69.2497 70.2201L69.163 68.1283L70.7249 68.0636L70.8116 70.1554L69.2497 70.2201ZM68.834 70.7366C69.1523 70.7234 69.2614 70.5028 69.2572 70.4009L70.8191 70.3362C70.8652 71.4477 69.925 72.256 68.8987 72.2985L68.834 70.7366ZM68.3676 70.0309C68.3719 70.1346 68.4424 70.3502 68.5944 70.5404C68.7539 70.7401 68.854 70.7358 68.834 70.7366L68.8987 72.2985C68.2064 72.3272 67.6791 71.8991 67.3732 71.5163C67.0598 71.1241 66.8265 70.5986 66.8057 70.0956L68.3676 70.0309ZM71.6844 70.1192L71.6616 69.5685L73.2235 69.5037L73.2463 70.0545L71.6844 70.1192ZM71.6616 69.5685L71.5977 68.0274L73.1596 67.9627L73.2235 69.5037L71.6616 69.5685ZM71.2612 70.4549C71.5795 70.4417 71.6886 70.2211 71.6844 70.1192L73.2463 70.0545C73.2923 71.166 72.3522 71.9743 71.3259 72.0168L71.2612 70.4549ZM70.8116 70.1554C70.8158 70.2573 70.9428 70.4681 71.2612 70.4549L71.3259 72.0168C70.2996 72.0593 69.2958 71.3316 69.2497 70.2201L70.8116 70.1554ZM73.673 69.8033C73.9914 69.7901 74.1005 69.5695 74.0962 69.4676L75.6581 69.4028C75.7042 70.5143 74.764 71.3226 73.7377 71.3652L73.673 69.8033ZM73.2235 69.5037C73.2277 69.6057 73.3547 69.8165 73.673 69.8033L73.7377 71.3652C72.7115 71.4077 71.7076 70.68 71.6616 69.5685L73.2235 69.5037ZM74.0962 69.4676L74.0324 67.9265L75.5943 67.8618L75.6581 69.4028L74.0962 69.4676ZM75.5397 66.5448L75.5943 67.8618L74.0324 67.9265L73.9778 66.6095L75.5397 66.5448ZM65.2279 63.9775L69.3366 62.7968L69.7684 64.2992L65.6596 65.48L65.2279 63.9775ZM70.1565 62.7443L73.0102 63.1813L72.7736 64.7265L69.9199 64.2895L70.1565 62.7443ZM65.3884 67.4802L65.4456 68.8607L63.8837 68.9255L63.8265 67.5449L65.3884 67.4802ZM65.4631 68.9568L66.0023 70.595L64.5174 71.0837L63.9782 69.4456L65.4631 68.9568ZM65.4456 68.8607C65.4469 68.8934 65.4528 68.9258 65.4631 68.9568L63.9782 69.4456C63.9228 69.2774 63.891 69.1024 63.8837 68.9255L65.4456 68.8607ZM69.3366 62.7968C69.6029 62.7203 69.8826 62.7024 70.1565 62.7443L69.9199 64.2895C69.8693 64.2818 69.8176 64.2851 69.7684 64.2992L69.3366 62.7968ZM75.2796 65.657C75.4374 65.9273 75.5267 66.232 75.5397 66.5448L73.9778 66.6095C73.9754 66.5517 73.9589 66.4954 73.9297 66.4454L75.2796 65.657ZM73.0259 64.898C72.972 64.8057 72.8792 64.7427 72.7736 64.7265L73.0102 63.1813C73.5821 63.2688 74.0839 63.61 74.3757 64.1096L73.0259 64.898ZM63.84 65.8046C63.847 64.9555 64.4117 64.2121 65.2279 63.9775L65.6596 65.48C65.5088 65.5233 65.4045 65.6607 65.4031 65.8176L63.84 65.8046ZM66.4995 70.8251C66.6873 70.8077 66.8285 70.6461 66.8207 70.4576L68.3826 70.3929C68.4249 71.4128 67.6607 72.2871 66.6442 72.3816L66.4995 70.8251ZM66.5164 72.3935C65.6262 72.4763 64.7969 71.933 64.5174 71.0837L66.0023 70.595C66.0539 70.7519 66.2072 70.8523 66.3717 70.837L66.5164 72.3935Z",
    fill: "#63B281",
    id: "path30",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2016 65.4358L76.0706 66.1875C75.9465 66.27 75.8744 66.4114 75.8806 66.5604L75.9756 68.8545C75.9818 69.0035 76.0653 69.1384 76.1959 69.2104L77.3852 69.8659C78.113 70.2671 78.9997 69.7183 78.9653 68.8879L78.8572 66.2798C78.8228 65.4494 77.8938 64.9758 77.2016 65.4358Z",
    fill: "#63B281",
    stroke: "#63B281",
    strokeWidth: 1.49285,
    strokeLinecap: "round",
    id: "path31",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7792 72.8197L39.0164 72.8216C39.5409 72.8258 40.0001 72.4703 40.1274 71.9615L40.5551 70.2528C40.5815 70.1473 40.5926 70.0386 40.5881 69.9299L40.5306 68.5424L40.3711 66.8327C40.3241 66.329 39.9497 65.9171 39.4528 65.8223L35.0116 64.9754C34.8563 64.9458 34.6964 64.9489 34.5424 64.9847L31.5505 65.6781C31.22 65.7547 30.941 65.975 30.7899 66.2787L29.9734 67.9199C29.888 68.0914 29.8475 68.2816 29.8554 68.473L29.9101 69.7938L29.9745 71.3477C29.9999 71.9595 30.5913 72.4318 31.2954 72.4026C31.9995 72.3735 32.5498 71.8538 32.5244 71.242L32.5475 71.7974C32.5728 72.4092 33.1642 72.8815 33.8683 72.8523C34.5725 72.8231 35.1227 72.3035 35.0974 71.6917L35.1049 71.874C35.1303 72.4858 35.7217 72.9581 36.4258 72.9289C37.1299 72.8998 37.6632 71.9706 37.6379 71.3588L37.6533 71.7308C37.6784 72.3358 38.1736 72.8148 38.7792 72.8197Z",
    fill: "#F3F3F0",
    id: "path32",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0164 72.8216L39.0226 72.04L39.0226 72.04L39.0164 72.8216ZM38.7792 72.8197L38.7729 73.6013L38.7729 73.6013L38.7792 72.8197ZM38.3408 69.4444C38.3229 69.0131 37.9588 68.678 37.5275 68.6958C37.0962 68.7137 36.7611 69.0778 36.7789 69.5091L38.3408 69.4444ZM40.5306 68.5424L41.3116 68.51L41.3108 68.4899L41.3089 68.4698L40.5306 68.5424ZM40.3711 66.8327L41.1493 66.76L41.1493 66.76L40.3711 66.8327ZM30.7899 66.2787L31.4897 66.6269L30.7899 66.2787ZM29.9734 67.9199L29.2736 67.5718L29.2736 67.5718L29.9734 67.9199ZM35.7909 69.5501C35.773 69.1188 35.4089 68.7836 34.9776 68.8015C34.5463 68.8194 34.2111 69.1835 34.229 69.6148L35.7909 69.5501ZM33.241 69.6558C33.2231 69.2245 32.859 68.8893 32.4277 68.9072C31.9964 68.9251 31.6612 69.2892 31.6791 69.7205L33.241 69.6558ZM29.9101 69.7938L30.6911 69.7614L30.6911 69.7614L29.9101 69.7938ZM29.8554 68.473L29.0745 68.5053L29.0745 68.5053L29.8554 68.473ZM39.4528 65.8223L39.5992 65.0546L39.5992 65.0546L39.4528 65.8223ZM35.0116 64.9754L34.8652 65.7432L34.8652 65.7432L35.0116 64.9754ZM34.5424 64.9847L34.3659 64.2232L34.3659 64.2232L34.5424 64.9847ZM31.5505 65.6781L31.7269 66.4395L31.7269 66.4395L31.5505 65.6781ZM40.5551 70.2528L41.3133 70.4426L41.3133 70.4426L40.5551 70.2528ZM40.1274 71.9615L39.3692 71.7717L39.3692 71.7717L40.1274 71.9615ZM39.0226 72.04L38.7854 72.0381L38.7729 73.6013L39.0101 73.6032L39.0226 72.04ZM38.4342 71.6984L38.4188 71.3264L36.8569 71.3911L36.8723 71.7631L38.4342 71.6984ZM38.4188 71.3264L38.3408 69.4444L36.7789 69.5091L36.8569 71.3911L38.4188 71.3264ZM41.3089 68.4698L41.1493 66.76L39.5929 66.9053L39.7524 68.615L41.3089 68.4698ZM30.0901 65.9306L29.2736 67.5718L30.6731 68.2681L31.4897 66.6269L30.0901 65.9306ZM35.8859 71.8417L35.8783 71.6593L34.3164 71.7241L34.324 71.9064L35.8859 71.8417ZM35.8783 71.6593L35.7909 69.5501L34.229 69.6148L34.3164 71.7241L35.8783 71.6593ZM36.3934 72.148C36.2234 72.155 36.0857 72.1007 35.9986 72.0311C35.9131 71.9629 35.888 71.8933 35.8859 71.8417L34.324 71.9064C34.3713 73.0489 35.4294 73.7525 36.4582 73.7099L36.3934 72.148ZM36.8569 71.3911C36.861 71.4892 36.8082 71.7091 36.6646 71.9148C36.5172 72.1259 36.4025 72.1476 36.3934 72.148L36.4582 73.7099C37.1532 73.6811 37.6572 73.2237 37.9462 72.8098C38.2389 72.3907 38.4401 71.8401 38.4188 71.3264L36.8569 71.3911ZM33.3284 71.765L33.3054 71.2097L31.7435 71.2744L31.7665 71.8297L33.3284 71.765ZM33.3054 71.2097L33.241 69.6558L31.6791 69.7205L31.7435 71.2744L33.3054 71.2097ZM33.836 72.0714C33.666 72.0784 33.5282 72.024 33.4411 71.9545C33.3557 71.8862 33.3305 71.8166 33.3284 71.765L31.7665 71.8297C31.8139 72.9723 32.8719 73.6759 33.9007 73.6332L33.836 72.0714ZM34.3164 71.7241C34.3186 71.7757 34.2993 71.8471 34.2198 71.9222C34.1387 71.9987 34.006 72.0643 33.836 72.0714L33.9007 73.6332C34.9294 73.5906 35.9257 72.8019 35.8783 71.6593L34.3164 71.7241ZM31.263 71.6217C31.093 71.6287 30.9553 71.5744 30.8682 71.5048C30.7828 71.4366 30.7576 71.367 30.7555 71.3153L29.1936 71.3801C29.2409 72.5226 30.299 73.2262 31.3278 73.1836L31.263 71.6217ZM31.7435 71.2744C31.7456 71.326 31.7264 71.3975 31.6469 71.4725C31.5658 71.5491 31.433 71.6147 31.263 71.6217L31.3278 73.1836C32.3565 73.141 33.3527 72.3522 33.3054 71.2097L31.7435 71.2744ZM30.7555 71.3153L30.6911 69.7614L29.1292 69.8262L29.1936 71.3801L30.7555 71.3153ZM29.0745 68.5053L29.1292 69.8262L30.6911 69.7614L30.6363 68.4406L29.0745 68.5053ZM39.5992 65.0546L35.158 64.2076L34.8652 65.7432L39.3064 66.5901L39.5992 65.0546ZM34.3659 64.2232L31.374 64.9166L31.7269 66.4395L34.7188 65.7461L34.3659 64.2232ZM39.7497 68.5748L39.8072 69.9623L41.3691 69.8976L41.3116 68.51L39.7497 68.5748ZM39.7969 70.063L39.3692 71.7717L40.8856 72.1513L41.3133 70.4426L39.7969 70.063ZM39.8072 69.9623C39.8086 69.9962 39.8051 70.0301 39.7969 70.063L41.3133 70.4426C41.3579 70.2645 41.3767 70.081 41.3691 69.8976L39.8072 69.9623ZM35.158 64.2076C34.8958 64.1576 34.626 64.1629 34.3659 64.2232L34.7188 65.7461C34.7669 65.7349 34.8168 65.734 34.8652 65.7432L35.158 64.2076ZM29.2736 67.5718C29.1296 67.8612 29.0611 68.1824 29.0745 68.5053L30.6363 68.4406C30.6339 68.3809 30.6465 68.3216 30.6731 68.2681L29.2736 67.5718ZM31.4897 66.6269C31.5368 66.5321 31.6238 66.4634 31.7269 66.4395L31.374 64.9166C30.8161 65.0459 30.3452 65.4178 30.0901 65.9306L31.4897 66.6269ZM41.1493 66.76C41.07 65.9098 40.438 65.2145 39.5992 65.0546L39.3064 66.5901C39.4614 66.6197 39.5782 66.7482 39.5929 66.9053L41.1493 66.76ZM38.7854 72.0381C38.5965 72.0366 38.442 71.8871 38.4342 71.6984L36.8723 71.7631C36.9147 72.7845 37.7507 73.5931 38.7729 73.6013L38.7854 72.0381ZM39.0101 73.6032C39.8955 73.6102 40.6706 73.0102 40.8856 72.1513L39.3692 71.7717C39.3295 71.9304 39.1862 72.0413 39.0226 72.04L39.0101 73.6032Z",
    fill: "#63B281",
    id: "path33",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3802 67.5004L28.5695 68.1559C28.7001 68.2279 28.7836 68.3628 28.7898 68.5118L28.8848 70.8059C28.891 70.9549 28.8189 71.0963 28.6948 71.1788L27.5638 71.9305C26.8717 72.3905 25.9426 71.9169 25.9082 71.0866L25.8001 68.4784C25.7657 67.648 26.6524 67.0992 27.3802 67.5004Z",
    fill: "#63B281",
    stroke: "#63B281",
    strokeWidth: 1.49285,
    strokeLinecap: "round",
    id: "path34",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0135 74.1652L52.6913 74.22L51.3407 74.276C51.2845 74.2783 51.2293 74.2944 51.1783 74.3232L50.4159 74.754C50.2674 74.838 50.169 75.0208 50.16 75.2294L49.9641 79.7941C49.9551 80.0043 50.0384 80.2058 50.1803 80.317L51.1179 81.0518C51.2451 81.1515 51.3263 81.3249 51.3341 81.5139L51.7079 90.5324C51.7214 90.8581 51.9963 91.1112 52.322 91.0977L54.4844 91.0081C54.8101 90.9946 55.0632 90.7196 55.0497 90.3939L54.6747 81.3451C54.6676 81.1724 54.7364 81.0052 54.8632 80.8878L55.7196 80.0939C55.8591 79.9645 55.9278 79.7758 55.9039 79.587L55.3246 75.0038C55.299 74.8016 55.171 74.6269 54.9859 74.5417L54.2849 74.2188C54.1999 74.1797 54.1069 74.1614 54.0135 74.1652Z",
    fill: "#63B281",
    stroke: "#63B281",
    strokeWidth: 1.77074,
    id: "path35",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3132 46.8684L46.203 53.4299",
    stroke: "#63B281",
    strokeWidth: 2.13448,
    strokeLinecap: "round",
    id: "path36",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8364 49.4644L63.3409 55.5976",
    stroke: "#63B281",
    strokeWidth: 2.13448,
    strokeLinecap: "round",
    id: "path37",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1006 8.10404C17.5648 17.8076 33.3464 21.6463 45.6091 16.1014C57.8718 10.5566 78.2385 4.15865 86.3425 8.74384C95.2709 13.7954 95.193 25.6983 84.8497 31.5631",
    stroke: "#63B281",
    strokeWidth: 3.19896,
    strokeLinecap: "round",
    strokeDasharray: "1.49 5.54",
    id: "path38",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8511 33.5076C25.7874 25.8301 16.0839 29.9887 11.1788 34.1474C6.27372 38.306 1.68851 57.7131 14.2711 59.8457C24.3372 61.5518 34.8511 56.6467 34.8511 56.6467",
    stroke: "#63B281",
    strokeWidth: 3.19896,
    strokeLinecap: "round",
    strokeDasharray: "1.49 5.54",
    id: "path39",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7456 50.2239C85.8093 47.3448 91.994 48.0912 94.5532 54.1693C96.6005 59.0317 94.4821 64.1571 93.1669 66.112",
    stroke: "#63B281",
    strokeWidth: 3.19896,
    strokeLinecap: "round",
    strokeDasharray: "1.49 5.54",
    id: "path40",
    style: {
      stroke: "#007191",
      strokeOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs40"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_6435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.632,
    height: 85.3057,
    fill: "white",
    transform: "translate(0.183838)",
    id: "rect40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLts1);
export default __webpack_public_path__ + "static/media/Icon_LTS1.c5233453dafa8ef5010b9e72486e9a0e.svg";
export { ForwardRef as ReactComponent };